import { useNavigate } from 'react-router-dom';
import styles from './SetUserInfo.module.css';

/**
 * 个人信息设置页（老项目为空框架）
 */
export const SetUserInfo: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <button className={styles.backBtn} onClick={() => navigate('/settings')}>
          &#8592;
        </button>
        <h1 className={styles.headerTitle}>个人信息</h1>
        <span className={styles.headerSpacer} />
      </header>
      <div className={styles.content}>
        <p className={styles.placeholder}>个人信息设置功能开发中...</p>
      </div>
    </div>
  );
};
